<template>
    <el-dialog :visible="visible"
               :close-on-click-modal="false"
               :show-close="false"
               @close="$emit('close')"
               @open="$emit('open')"
               :width="width"
               top="2vh"
               append-to-body
               custom-class="x-modal-container">
        <div class="x-modal" v-loading="loading">
            <div class="x-modal-header">
                <div class="title">
                    {{ title }}
                </div>
                <div class="button-close">

                </div>
            </div>
            <div class="x-modal-body">
                <slot></slot>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default  {
    name: 'XModal',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
        loading: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '480px'
        }
    },
    data() {
        return {}
    },
    methods: {
    }
}
</script>
